<app-accordion
    *ngIf="(product?.activeSplashes | isPreOrder) && (product?.activeSplashes | getPrioritySplash:['ProductSplash2']) as splash"
    class="accordion-group"
    type="group"
    [adjustVelocity]="true">
    <div slot="header">
        <h2 class="display-5">{{ 'productDetail.headlines.preOrder' | translateSafe }}</h2>
    </div>
    <div slot="content">
        <p [innerHTML]="'productDetail.feedback.preOrderConditions' | translateSafe : {
            startDate: splash?.startDate | date: 'ww',
            endDate: splash?.endDate | date: 'ww'
        } "></p>
    </div>
</app-accordion>

<app-accordion class="accordion-group" type="group" [adjustVelocity]="true">
    <div slot="header">
        <h2 class="display-5">{{ 'productDetail.headlines.description' | translate }}</h2>
    </div>
    <div slot="content">
        <div [innerHTML]="product?.productDescription | safe : 'html'"></div>
        @if (product?.showAIText) {
            <span class="ai-generated-text">
                <app-svg-icon class="d-none d-lg-block" iconName="paper"></app-svg-icon>
                <p [innerHTML]="'productDetail.feedback.aiText' | translateSafe"></p>
            </span>
        }
    </div>
</app-accordion>

<ng-container
    *ngIf="(((product | normalizeProperties) ?? {}) | keyvalue)?.length || product?.relatedProperties?.length"
>
    <app-accordion class="accordion-group" type="group" [adjustVelocity]="true">
        <div slot="header">
            <h2 class="display-5">{{ 'productDetail.headlines.specifications' | translate }}</h2>
        </div>
        <app-product-specifications slot="content"></app-product-specifications>
    </app-accordion>
</ng-container>

<ng-container
    *ngIf="product?.activeSplashes | getSplashes:['ProductSplash1', 'ProductSplash3', 'ProductSplash4'] as splashes">
    <app-accordion *ngFor="let splash of splashes" class="accordion-group" type="group" [adjustVelocity]="true">
        <div slot="header">
            <h2 class="display-5">{{ ('productDetail.headlines.' + (splash.type | lowerCaseFirstLetter)) | translate }}</h2>
        </div>
        <div slot="content">
            <p [innerHTML]="('productDetail.feedback.' + (splash.type | lowerCaseFirstLetter)) | translate"
               appInterceptLinks></p>
        </div>
    </app-accordion>
</ng-container>

@if (product?.hasBurdDelivery) {
    <app-accordion *appSameDayDeliveryInOffMode class="accordion-group" type="group" [adjustVelocity]="true">
        <div slot="header">
            <h2 class="display-5">{{ 'productDetail.headlines.burdDelivery' | translateSafe }}</h2>
        </div>
        <div slot="content">
            <app-same-day-delivery class="same-day-delivery" layout="little" place="pdp"></app-same-day-delivery>
        </div>
    </app-accordion>
}
